function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.52 44.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.68,14.84a1.86,1.86,0,0,0-2.62,0l-4.8,4.8-4.8-4.8a1.85,1.85,0,0,0-2.62,2.62l4.8,4.8-4.8,4.8a1.85,1.85,0,0,0,2.62,2.62l4.8-4.8,4.8,4.8a1.85,1.85,0,0,0,2.62-2.62l-4.8-4.8,4.8-4.8A1.86,1.86,0,0,0,29.68,14.84Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.26,0A22.26,22.26,0,1,0,44.52,22.26,22.26,22.26,0,0,0,22.26,0Zm0,40.81A18.55,18.55,0,1,1,40.81,22.26,18.55,18.55,0,0,1,22.26,40.81Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.4b374708.svg";
export { ForwardRef as ReactComponent };